import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { View, Text } from '@olxbr/design-system'
import { Modal } from '@olxbr/ds-web'
import Icons from '@olxbr/olx-icons'
import LabelBox from '../../atoms/LabelBox'
import PurplePlaneIcon from '../../atoms/PurplePlaneIcon'
import GenericBox from '../../atoms/GenericBox'
import { truncate } from '../../../util/mask'
import Lurker from '../../../util/lurker'

const lurker = new Lurker('email_change_activation_sent')

const Content = styled(View)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const LabelBoxView = styled(View)`
  padding: 7px 50px;
`

const TitleWrapper = styled(View)`
  margin-top: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Description = styled(Text)`
  text-align: center;
  margin-top: 24px;
  margin-bottom: 8px;
`
const SafetyTip = styled(View)`
  display: flex;
  flex-direction: row;
`

const Divider = styled(View)`
  height: 16px;
`

const BoxWrapper = styled(View)`
  width: 100%;
  margin-top: 32px;
`

const IconWrapper = styled(View)`
  margin-right: 8px;
`

const modalClose = onClose => () => {
  lurker.clickEvt('modal_close')
  if (onClose && typeof onClose === 'function') {
    onClose()
  }
}

const EmailChangeActivationSentModal = ({ email, onClose, open }) => (
  <Modal onClose={modalClose(onClose)} maxWidth="400px" maxHeight="550px" open={open}>
    <Content>
      <PurplePlaneIcon />
      <TitleWrapper>
        <span className="typo-title-medium font-semibold">Ative o</span>
        <span className="typo-title-medium font-bold">novo e-mail</span>
      </TitleWrapper>
      <Description size="body1" weight="regular">
        O e-mail de ativação foi enviado para
      </Description>
      <LabelBoxView>
        <LabelBox>{truncate(email)}</LabelBox>
      </LabelBoxView>
      <BoxWrapper>
        <GenericBox direction="column">
          <SafetyTip>
            <IconWrapper>
              <Icons.System.Lock size="16" color="#999999" />
            </IconWrapper>
            <span className="typo-body-small text-neutral-120">
              Não será compartilhado no seu perfil.
            </span>
          </SafetyTip>
          <Divider />
          <SafetyTip>
            <IconWrapper>
              <Icons.System.Award size="16" color="#999999" />
            </IconWrapper>
            <span className="typo-body-small text-neutral-120">
              Conquistará selo de e-mail verificado.
            </span>
          </SafetyTip>
        </GenericBox>
      </BoxWrapper>
    </Content>
  </Modal>
)

EmailChangeActivationSentModal.propTypes = {
  email: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
}

export default EmailChangeActivationSentModal
